export default __webpack_public_path__ + "static/media/leaguePro2.3ba9bb45.jpg";